import QuerySelector from "../decorators/query-selector"
import TrackingService from "../services/tracking-service"

const encodedURL: string = encodeURIComponent(location.href)
const introCopy: string = "I've found some ideas on where to go on the Virgin Holidays website. Let me know what you think!%0A%0A"
const HREF_ATTRIBUTE: string = 'href'

export default class Sharing {

    @QuerySelector('[whatsapp-share]')
    private whatsapp: HTMLAnchorElement
    @QuerySelector('[messenger-share]')
    private messenger: HTMLAnchorElement
    @QuerySelector('[pinterest-share]')
    private pinterest: HTMLAnchorElement
    @QuerySelector('[sms-share]')
    private sms: HTMLAnchorElement
    @QuerySelector('[email-share]')
    private email: HTMLAnchorElement

    public init(): void {
        this.updateHref(this.whatsapp, `whatsapp://send?text=${introCopy}${encodedURL}&utm_medium=Social_Sharing&utm_source=virginholidays.co.uk&utm_campaign=Shared_whatsapp&utm_content=Hotlist&gaID=GA1.3.629618644.1550659584`)
        this.updateHref(this.messenger, `fb-messenger://share?link=${encodedURL}&utm_medium=Social_Sharing&utm_source=virginholidays.co.uk&utm_campaign=Shared_facebook&utm_content=Hotel_Options&gaID=GA1.3.629618644.1550659584`)
        this.updateHref(this.pinterest, `https://www.pinterest.co.uk/pin/create/button?url=${encodedURL}&media=https://virginholidays.co.uk/hotlist/assets/images/stacked-vhols-logo.png&utm_medium=Social_Sharing&utm_source=virginholidays.co.uk&utm_campaign=Shared_pinterest&utm_content=Hotlist&gaID=GA1.3.629618644.1550659584`)
        this.updateHref(this.sms, `sms:?&body=${introCopy}${encodedURL}&utm_medium=Social_Sharing%26utm_source=virginholidays.co.uk%26utm_campaign=Shared_sms%26utm_content=Hotel_Options%26gaID=GA1.3.629618644.1550659584`)
        this.updateHref(this.email, `mailto:?subject=${introCopy}&body=${encodedURL}&utm_medium=Social_Sharing%26utm_source=virginholidays.co.uk%26utm_campaign=Shared_email%26utm_content=Hotel_Options%26gaID=GA1.3.629618644.1550659584`)
    }

    private updateHref(element: HTMLAnchorElement, url: string): void {
        element.setAttribute(HREF_ATTRIBUTE, url)
        element.addEventListener('click', () => TrackingService.trackEvent('WISHLIST_SHARE_CLICKED', [
            url,
            element.getAttribute('aria-label'),
            [
                this.whatsapp.getAttribute(HREF_ATTRIBUTE),
                this.messenger.getAttribute(HREF_ATTRIBUTE),
                this.pinterest.getAttribute(HREF_ATTRIBUTE),
                this.sms.getAttribute(HREF_ATTRIBUTE),
                this.email.getAttribute(HREF_ATTRIBUTE)
            ]
        ]))
    }
}